/**
 * learn.4klabs.ai — teacher / school insights dashboard.
 *
 * No-login surface reached by a class (in production, a teacher) code; for the
 * demo it always opens the fully-populated sample class. The dashboard itself is
 * driven by mock data shaped exactly like the signals we capture from INX videos
 * and assessments, so it is a faithful preview of the live product.
 */

import { createFileRoute, Link } from '@tanstack/react-router';
import { LayoutGrid } from 'lucide-react';
import { useLearnTheme, LearnRoot, LearnTopBar } from '../components/learn/learnShared';
import { TeacherDashboard } from '../components/learn/insights/TeacherDashboard';
import { LensTabs } from '../components/learn/insights/portalShell';

export const Route = createFileRoute('/learn/teacher')({
  component: TeacherDashboardPage,
});

function TeacherDashboardPage() {
  const { theme, toggle } = useLearnTheme();
  return (
    <LearnRoot theme={theme}>
      <LearnTopBar
        theme={theme}
        onToggle={toggle}
        right={
          <div className="flex items-center gap-2">
            <LensTabs active="teacher" />
            <Link to="/learn"
              className="inline-flex items-center gap-1.5 rounded-xl border border-black/10 bg-black/[0.03] px-3 py-2 text-[13px] font-semibold text-[#56505F] transition-colors hover:text-[#1B1826] dark:border-white/10 dark:bg-white/[0.05] dark:text-[#B2B0C0] dark:hover:text-white">
              <LayoutGrid className="h-4 w-4" /> Catalog
            </Link>
          </div>
        }
      />
      <main className="mx-auto max-w-[1240px] px-6 pb-20">
        <TeacherDashboard />
      </main>
    </LearnRoot>
  );
}
